export enum Environment{
    PRODUCTION = "PRODUCTION",
    DESIGN = "DESIGN"
}